

import { Toaster } from "sonner"
import { useTheme } from "@/context/ThemeContext"

export function SonnerProvider() {
  const { theme } = useTheme()

  return <Toaster position="top-right" theme={theme as "light" | "dark"} closeButton richColors />
}

